import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  OkRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {Role, RoleBindUserReq, RoleCreateReq, RoleUpdateReq, Roles} from '../types/role';
import {Users} from '../types/user';

/**
 * RoleServiceApi - axios parameter creator
 * @export
 */
export const RoleServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 角色和用户绑定
     * @summary 角色和用户绑定
     * @param {string} roleId
     * @param {RoleBindUserReq} roleBindUserReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceBindUser: async (
      roleId: string,
      roleBindUserReq: RoleBindUserReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('roleServiceBindUser', 'roleId', roleId);
      // verify required parameter 'roleBindUserReq' is not null or undefined
      assertParamExists('roleServiceBindUser', 'roleBindUserReq', roleBindUserReq);
      const localVarPath = `/role/role/{roleId}/user_role`.replace(
        `{${'roleId'}}`,
        encodeURIComponent(String(roleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleBindUserReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色创建
     * @summary 角色创建
     * @param {RoleCreateReq} roleCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceCreate: async (
      roleCreateReq: RoleCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleCreateReq' is not null or undefined
      assertParamExists('roleServiceCreate', 'roleCreateReq', roleCreateReq);
      const localVarPath = `/role/role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色删除
     * @summary 角色删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('roleServiceDelete', 'id', id);
      const localVarPath = `/role/role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色详情
     * @summary 角色详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('roleServiceDetail', 'id', id);
      const localVarPath = `/role/role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色查询
     * @summary 角色查询
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceFind: async (
      orgId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/role/roles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色关联用户查询
     * @summary 角色关联用户查询
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceGetUsers: async (
      roleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('roleServiceGetUsers', 'roleId', roleId);
      const localVarPath = `/role/role/{roleId}/users`.replace(
        `{${'roleId'}}`,
        encodeURIComponent(String(roleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色初始化
     * @summary 角色初始化
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceInitDefault: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/role/init-role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户和角色解绑
     * @summary 用户和角色解绑
     * @param {string} roleId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceUnbindUser: async (
      roleId: string,
      userId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('roleServiceUnbindUser', 'roleId', roleId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('roleServiceUnbindUser', 'userId', userId);
      const localVarPath = `/role/role/{roleId}/user_role/{userId}`
        .replace(`{${'roleId'}}`, encodeURIComponent(String(roleId)))
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 角色修改
     * @summary 角色修改
     * @param {string} roleId
     * @param {RoleUpdateReq} roleUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceUpdate: async (
      roleId: string,
      roleUpdateReq: RoleUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('roleServiceUpdate', 'roleId', roleId);
      // verify required parameter 'roleUpdateReq' is not null or undefined
      assertParamExists('roleServiceUpdate', 'roleUpdateReq', roleUpdateReq);
      const localVarPath = `/role/role/{roleId}`.replace(
        `{${'roleId'}}`,
        encodeURIComponent(String(roleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RoleServiceApi - functional programming interface
 * @export
 */
export const RoleServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoleServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 角色和用户绑定
     * @summary 角色和用户绑定
     * @param {string} roleId
     * @param {RoleBindUserReq} roleBindUserReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceBindUser(
      roleId: string,
      roleBindUserReq: RoleBindUserReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceBindUser(
        roleId,
        roleBindUserReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceBindUser']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色创建
     * @summary 角色创建
     * @param {RoleCreateReq} roleCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceCreate(
      roleCreateReq: RoleCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceCreate(
        roleCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceCreate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色删除
     * @summary 角色删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色详情
     * @summary 角色详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceDetail']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色查询
     * @summary 角色查询
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceFind(
      orgId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Roles>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceFind(orgId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceFind']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色关联用户查询
     * @summary 角色关联用户查询
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceGetUsers(
      roleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Users>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceGetUsers(
        roleId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceGetUsers']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色初始化
     * @summary 角色初始化
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceInitDefault(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceInitDefault(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceInitDefault']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户和角色解绑
     * @summary 用户和角色解绑
     * @param {string} roleId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceUnbindUser(
      roleId: string,
      userId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceUnbindUser(
        roleId,
        userId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceUnbindUser']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 角色修改
     * @summary 角色修改
     * @param {string} roleId
     * @param {RoleUpdateReq} roleUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roleServiceUpdate(
      roleId: string,
      roleUpdateReq: RoleUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roleServiceUpdate(
        roleId,
        roleUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoleServiceApi.roleServiceUpdate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RoleServiceApi - factory interface
 * @export
 */
export const RoleServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RoleServiceApiFp(configuration);
  return {
    /**
     * 角色和用户绑定
     * @summary 角色和用户绑定
     * @param {string} roleId
     * @param {RoleBindUserReq} roleBindUserReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceBindUser(
      roleId: string,
      roleBindUserReq: RoleBindUserReq,
      options?: any
    ): AxiosPromise<OkRsp> {
      return localVarFp
        .roleServiceBindUser(roleId, roleBindUserReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 角色创建
     * @summary 角色创建
     * @param {RoleCreateReq} roleCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceCreate(roleCreateReq: RoleCreateReq, options?: any): AxiosPromise<IdRsp> {
      return localVarFp
        .roleServiceCreate(roleCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 角色删除
     * @summary 角色删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.roleServiceDelete(id, options).then(request => request(axios, basePath));
    },
    /**
     * 角色详情
     * @summary 角色详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceDetail(id: string, options?: any): AxiosPromise<Role> {
      return localVarFp.roleServiceDetail(id, options).then(request => request(axios, basePath));
    },
    /**
     * 角色查询
     * @summary 角色查询
     * @param {string} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceFind(orgId?: string, options?: any): AxiosPromise<Roles> {
      return localVarFp.roleServiceFind(orgId, options).then(request => request(axios, basePath));
    },
    /**
     * 角色关联用户查询
     * @summary 角色关联用户查询
     * @param {string} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceGetUsers(roleId: string, options?: any): AxiosPromise<Users> {
      return localVarFp
        .roleServiceGetUsers(roleId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 角色初始化
     * @summary 角色初始化
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceInitDefault(options?: any): AxiosPromise<void> {
      return localVarFp.roleServiceInitDefault(options).then(request => request(axios, basePath));
    },
    /**
     * 用户和角色解绑
     * @summary 用户和角色解绑
     * @param {string} roleId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceUnbindUser(roleId: string, userId: string, options?: any): AxiosPromise<OkRsp> {
      return localVarFp
        .roleServiceUnbindUser(roleId, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 角色修改
     * @summary 角色修改
     * @param {string} roleId
     * @param {RoleUpdateReq} roleUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roleServiceUpdate(
      roleId: string,
      roleUpdateReq: RoleUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .roleServiceUpdate(roleId, roleUpdateReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * RoleServiceApi - object-oriented interface
 * @export
 * @class RoleServiceApi
 * @extends {BaseAPI}
 */
export class RoleServiceApi extends BaseAPI {
  /**
   * 角色和用户绑定
   * @summary 角色和用户绑定
   * @param {string} roleId
   * @param {RoleBindUserReq} roleBindUserReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceBindUser(
    roleId: string,
    roleBindUserReq: RoleBindUserReq,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceBindUser(roleId, roleBindUserReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色创建
   * @summary 角色创建
   * @param {RoleCreateReq} roleCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceCreate(roleCreateReq: RoleCreateReq, options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceCreate(roleCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色删除
   * @summary 角色删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色详情
   * @summary 角色详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色查询
   * @summary 角色查询
   * @param {string} [orgId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceFind(orgId?: string, options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceFind(orgId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色关联用户查询
   * @summary 角色关联用户查询
   * @param {string} roleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceGetUsers(roleId: string, options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceGetUsers(roleId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色初始化
   * @summary 角色初始化
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceInitDefault(options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceInitDefault(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户和角色解绑
   * @summary 用户和角色解绑
   * @param {string} roleId
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceUnbindUser(roleId: string, userId: string, options?: RawAxiosRequestConfig) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceUnbindUser(roleId, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 角色修改
   * @summary 角色修改
   * @param {string} roleId
   * @param {RoleUpdateReq} roleUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleServiceApi
   */
  public roleServiceUpdate(
    roleId: string,
    roleUpdateReq: RoleUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return RoleServiceApiFp(this.configuration)
      .roleServiceUpdate(roleId, roleUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
